"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const getWidth = {
  small: "200",
  medium: "324",
  large: "500"
};

const StyledInput = _styledComponents2.default.input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-9l21hc-0"
})(["", " height:40px;width:", "px;border:1px solid ", ";border-radius:6px;padding:", "px;box-sizing:border-box;&:focus{border-color:", ";color:", ";outline:none;}&::-webkit-input-placeholder{color:", ";}&::-moz-placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&:-moz-placeholder{color:", ";}"], _styles.defaultBody, props => getWidth[props.size], props => props.error ? _styles.colors.red : _styles.colors.border, (0, _styles.calcPadding)(3), props => props.error ? _styles.colors.red : _styles.colors.accentFocusInput, _styles.colors.black, _styles.colors.greyInput, _styles.colors.greyInput, _styles.colors.greyInput, _styles.colors.greyInput);

/**
 * Input component specifically for text and password form inputs.
 */
const Input = (_ref) => {
  let {
    type = "text",
    size = "small",
    error = null,
    innerRef
  } = _ref,
      props = _objectWithoutProperties(_ref, ["type", "size", "error", "innerRef"]);

  return _react2.default.createElement(StyledInput, _extends({
    type: type,
    size: size,
    error: error
  }, props, {
    ref: innerRef
  }));
};

Input.propTypes = {
  className: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(["text", "password"]),
  size: _propTypes2.default.oneOf(["small", "medium", "large"]),
  error: _propTypes2.default.string,
  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
};

exports.default = Input;